import Vue from 'vue'
import Vuex from 'vuex'
import browser from '@/utils/browser'
import { generateRandomID } from '@/utils'
import {
    setAccounts,
    setLocalAccountData,
} from '@/utils/storage'
import {
    bakLogin,
    collectPlayTime,
    gameService,
    getWxAuthOpenid,
    tokenLogin,
    googleLogin,
    userLogin,
    userRegister,
    getCodeList,
    getMyCode,
    getNewNotice,
    checkGameUser,
} from '@/service'
import router from '@/router'
import app from './modules/app'
import user from './modules/user'
import { Dialog, Toast } from 'vant'
import { $t } from '@/utils/languages'


Vue.use(Vuex)

let VerifyPointingTimer = null

export default new Vuex.Store({
    modules: {
        app,
        user,
    },
    state: {
        accountData: {
            is_verified: '',
            login_sign: '',
            login_type: '',
            openid: '',
            reg_time: '',
            timestamp: '',
            user_token: '',
            username: '',
        },
        gameUrl: '',
        gameFrameInfo: {
            id: 'game-frame',
            frame: null,
        },
        serviceInfo: {
            title: '',
            describe: '',
            service_time: '',
            phone: '',
            qq: '',
            qq_group_id: '',
            social_media: [],
        },
        verifyInfo: {
            anti: 0,
            /**
             * 0 不实名；
             * 1 实名可跳过（登录、支付）；
             * 2 强制实名；
             * 3 实名可跳过（登录）
             * */
            api_time: 300, // 强制实名认证时，每隔该间隔给后台打点
            id_card: '', // 已绑身份证
            is_verified: false, // 是否已经实名
        },
        allCodeList: [
            // //所有的礼包码列表
            // {
            //     logo: '',//	游戏logo
            //     id: '',//礼包码id
            //     name: '',//礼包名称
            //     content: '',//礼包内容
            //     code: '',//	礼包码
            //     validity: '',//礼包有效期
            // }
        ],
        myCodeList: [
            // //我的礼包码列表
            // {
            //     logo: '',//	游戏logo
            //     id: '',//礼包码id
            //     name: '',//礼包名称
            //     content: '',//礼包内容
            //     code: '',//	礼包码
            //     validity: '',//礼包有效期
            // }
        ],
        notice: {
            id: '',//公告id
            title: '',//	公告标题
            content: '',//公告内容
            img: '',//公告图片
            elastic: '',//弹出类型，1-不弹出，2-只弹一次，3-每次都弹
        },
        firstOpen: true,
        isFirstOpenByLogin: true,
    },
    actions: {
        // 生成账户密码
        generateAccount({ dispatch }, { account = '', password = '' } = {}) {
            let accountData = {
                account: account || generateRandomID(9),
                password: password || generateRandomID(9),
            }
            if (Number(accountData.account[0]) === 0) {
                return dispatch('generateAccount')
            } else {
                return accountData
            }
        },
        // 保存账户信息
        saveAccountData({ commit, state }, data) {
            setLocalAccountData(data)
            const appConfig = state.app.appConfig
            if (appConfig.game) {
                let url = `${appConfig.game}`
                let query = [];
                ([
                    'username',
                    'login_sign',
                    'timestamp',
                    'game_id',
                    'muid',
                    'reg_time',
                    'model',
                    'openid',
                ]).forEach(key => {
                    let value = data[key] || state.accountData[key] ||
                        appConfig[key]
                    if (value !== undefined) {
                        query.push(`${key}=${value}`)
                    }
                })
                url = `${url.replace(/[&|?]$/, '')}${/\?/g.test(url)
                    ? '&'
                    : '?'}${query.join('&')}`
                commit('UPDATE_GAME_URL', url)
            }
            console.log('saveAccountData', data)
            return commit('UPDATE_ACCOUNT_DATA', data)
        },
        // 更新账户信息
        updateAccountData({ commit }, data) {
            console.log('update', data)
            commit('UPDATE_ACCOUNT_DATA', data)
        },
        // 获取游戏客服信息
        getGameService({ commit, state }) {
            return gameService({ game_id: state.app.appConfig.game_id }).
                then(res => {
                    console.log('getGameService res ', res)
                    if (Number(res.code) === 0) {
                        return commit('UPDATE_GAME_SERVICE', res.data)
                    }
                })
        },
        // 传递game_id username到服务端，服务端获取到open_id后将游戏与用户信息绑定（未使用）
        // 后台获取到的open_id在之后的微信支付流程中会再次使用
        getWxAuthorOpenId({ state }) {
            console.log('start getWxAuthorOpenId')
            const { accountData } = state
            const { appConfig } = app.state
            getWxAuthOpenid({
                game_id: appConfig.game_id,
                username: accountData.username,
            }).then(res => {
                
            })
        },
        // 2022.05.17 新旧注册用户加载不同游戏链接
        checkGameUrl({ commit, dispatch, state }) {
            let theGameUrl
            const _loading = Toast.loading({
                duration: 0,
                message: `${$t('加载游戏')}...`,
                loadingType: 'spinner'
            })
            checkGameUser({
                game_id: state?.app?.appConfig?.game_id,
                reg_time: state?.accountData?.reg_time
            }).then((res) => {
                // 新旧用户检测
                if (res?.data?.is_replace === true) {
                    const { game_id, new_link } = res.data
                    dispatch('app/updateAppConfig', {
                        game_id,
                        game: new_link
                    })

                    // 重新生成游戏链接
                    let url = new_link
                    let query = [];
                    ([
                        'username',
                        'login_sign',
                        'timestamp',
                        'game_id',
                        'muid',
                        'reg_time',
                        'model',
                        'openid',
                    ]).forEach(key => {
                        let value = state.accountData[key] || state.app.appConfig[key]
                        if (value !== undefined) {
                            if (key === 'game_id') {
                                query.push(`${key}=${game_id}`)
                            } else {
                                query.push(`${key}=${value}`)
                            }
                        }
                    })
                    url = `${url.replace(/[&|?]$/, '')}${/\?/g.test(url)
                        ? '&'
                        : '?'}${query.join('&')}`
                    commit('UPDATE_GAME_URL', url)

                    // 更新游戏链接
                    theGameUrl = url
                }
            }).finally(() => {
                _loading.clear()
                // 进入创建游戏流程
                dispatch('createGame', { theGameUrl })
            })
        },
        // 创建游戏iframe
        createGame({ commit, dispatch, state }, params) {
            const { theGameUrl } = params
            console.log('createGame', theGameUrl || state.gameUrl)
            let frame = document.createElement('iframe')
            const frameID = state.gameFrameInfo.id
            frame.classList.add('game-frame', 'depth-3')
            frame.setAttribute('id', frameID)
            frame.setAttribute('frameborder', '0')
            frame.setAttribute('src', theGameUrl || state.gameUrl)
            // frame.setAttribute('sandbox', 'allow-top-navigation allow-scripts allow-same-origin')
            document.body.appendChild(frame)
            // dispatch('pointPlaytime')
            commit('UPDATE_GAME_FRAME_CONTENT', frame)
            
            // 2022.01.17 暂时屏蔽 礼包码、公共 等内容
            // dispatch('getCodeList')
            // dispatch('getMyCode')
            // dispatch('getNewNotice')
        },
        // 关闭游戏
        closeGame({ dispatch }) {
            dispatch('stopPointPlaytime')
        },
        /**
         * @description iOS桌面书签登录
         *  @param commit
         * @param state
         * @param dispatch
         * @param payload {{ game_id: string back: string username: string }}*/
        bakLogin({ commit, state, dispatch }, payload) {
            return bakLogin(payload)
        },
        // 用户登录（token登录）
        tokenLogin({ dispatch, commit }, payload) {
            return tokenLogin(payload).then((res) => {
                if (Number(res.code) === 0) {
                    dispatch('app/updateAppConfig', {username:res.data.username})
                    dispatch('updateVerifyInfo', res.data)
                    let { currentRoute } = router
                    console.log('res', res, currentRoute)
                    let { query = {} } = currentRoute
                    query.bak = res.data.bak
                    query.username = res.data.username
                    query.game = encodeURIComponent(query.game);
                    window.history.replaceState({}, document.title,
                        `${window.location.origin}${router.currentRoute.path}?${Object.entries(
                            query).
                            map(([key, value]) => `${key}=${value}`).
                            join('&')}`)

                    // 2022.04.11 登录成功后回传账号名给安卓端
                    try {
                        const lgName = res?.data?.username || ''
                        window?.JHJsImpl?.login?.(lgName)
                        console.log('JHJsImpl.login<Android> | auto >>> ', lgName)

                        // 2024.01.16 安卓新壳包
                        window?.JsJingYouNativeBridge?.jsJingYouLogin?.(0, lgName)
                        console.log('JsJingYouNativeBridge.jsJingYouLogin<Android> | auto >>> ', lgName)
                    } catch (err) {
                        console.log('回传安卓端失败：', err)
                    }

                    // 2026.09.21 回传ios壳包 - 高质量用户上报（注册24小时内累计充值满20元用户，一生仅上报一次）
                    if (res?.data?.is_high_purchase === true) {
                        try {
                            const moneyStr = `${res?.data?.total_money ?? ''}`
                            window?.webkit?.messageHandlers?.high_purchase?.postMessage?.(moneyStr)
                            console.log('webkit.messageHandlers<ios> | high_purchase.postMessage >>> ', moneyStr)
                        } catch (err) {
                            console.log('回传ios端失败：', err)
                        }
                    }

                    // 2026.10.23 回传安卓壳包 - 高净值上报（注册24小时内累计充值满20元用户，一生仅上报一次）
                    if (res?.data?.is_high_purchase === true) {
                        try {
                            const moneyStr = `${res?.data?.total_money ?? ''}`
                            window?.JsJingYouNativeBridge?.highPurchase?.(moneyStr)
                            console.log('JsJingYouNativeBridge.highPurchase<Android> | highPurchase >>> ', moneyStr)
                        } catch (err) {
                            console.log('回传安卓端失败：', err)
                        }
                    }
                }
                return Promise.resolve(res)
            }).catch((err) => Promise.reject(err))
        },
        // 谷歌登录
        googleLogin({ dispatch, commit }, payload) {
            return googleLogin(payload).then((res) => {
                if (Number(res.code) === 0) {
                    dispatch('app/updateAppConfig', {username:res.data.username})
                    dispatch('updateVerifyInfo', res.data)
                    let { currentRoute } = router
                    console.log('res', res, currentRoute)
                    let { query = {} } = currentRoute
                    query.bak = res.data.bak
                    query.username = res.data.username
                    query.game = encodeURIComponent(query.game);
                    window.history.replaceState({}, document.title,
                        `${window.location.origin}${router.currentRoute.path}?${Object.entries(
                            query).
                            map(([key, value]) => `${key}=${value}`).
                            join('&')}`)

                    // 2022.04.11 登录成功后回传账号名给安卓端
                    try {
                        const lgName = res?.data?.username || ''
                        window?.JHJsImpl?.login?.(lgName)
                        console.log('JHJsImpl.login<Android> | auto >>> ', lgName)

                        // 2024.01.16 安卓新壳包
                        window?.JsJingYouNativeBridge?.jsJingYouLogin?.(0, lgName)
                        console.log('JsJingYouNativeBridge.jsJingYouLogin<Android> | auto >>> ', lgName)
                    } catch (err) {
                        console.log('回传安卓端失败：', err)
                    }
                }
                return Promise.resolve(res)
            }).catch((err) => Promise.reject(err))
        },
        // 用户登录
        userLogin({ dispatch, commit }, payload) {
            return userLogin(payload).then((res) => {
                if (Number(res.code) === 0) {
                    dispatch('app/updateAppConfig', {username:res.data.username})
                    dispatch('updateVerifyInfo', res.data)
                    let { currentRoute } = router
                    console.log('res', res, currentRoute)
                    let { query = {} } = currentRoute
                    query.bak = res.data.bak
                    query.username = res.data.username
                    query.game = encodeURIComponent(query.game);
                    window.history.replaceState({}, document.title,
                        `${window.location.origin}${router.currentRoute.path}?${Object.entries(
                            query).
                            map(([key, value]) => `${key}=${value}`).
                            join('&')}`)

                    // 2022.04.11 登录成功后回传账号名给安卓端
                    try {
                        const lgName = res?.data?.username || ''
                        window?.JHJsImpl?.login?.(lgName)
                        console.log('JHJsImpl.login<Android> | >>> ', lgName)

                        // 2024.01.16 安卓新壳包
                        window?.JsJingYouNativeBridge?.jsJingYouLogin?.(0, lgName)
                        console.log('JsJingYouNativeBridge.jsJingYouLogin<Android> | >>> ', lgName)
                    } catch (err) {
                        console.log('回传安卓端失败：', err)
                    }

                    // 2026.09.21 回传ios壳包 - 高质量用户上报（注册24小时内累计充值满20元用户，一生仅上报一次）
                    if (res?.data?.is_high_purchase === true) {
                        try {
                            const moneyStr = `${res?.data?.total_money ?? ''}`
                            window?.webkit?.messageHandlers?.high_purchase?.postMessage?.(moneyStr)
                            console.log('webkit.messageHandlers<ios> | high_purchase.postMessage >>> ', moneyStr)
                        } catch (err) {
                            console.log('回传ios端失败：', err)
                        }
                    }

                    // 2026.10.23 回传安卓壳包 - 高净值上报（注册24小时内累计充值满20元用户，一生仅上报一次）
                    if (res?.data?.is_high_purchase === true) {
                        try {
                            const moneyStr = `${res?.data?.total_money ?? ''}`
                            window?.JsJingYouNativeBridge?.highPurchase?.(moneyStr)
                            console.log('JsJingYouNativeBridge.highPurchase<Android> | highPurchase >>> ', moneyStr)
                        } catch (err) {
                            console.log('回传安卓端失败：', err)
                        }
                    }
                }
                return Promise.resolve(res)
            }).catch((err) => Promise.reject(err))
        },
        // 注册
        userRegister({ dispatch, commit }, payload) {
            return new Promise((resolve, reject) => {
                userRegister(payload).then(res => {
                    if (Number(res.code) === 0) {
                        dispatch('app/updateAppConfig', {username:res.data.username})
                        dispatch('updateVerifyInfo', res.data)
                        let { currentRoute } = router
                        console.log('res', res, currentRoute)
                        let { query = {} } = currentRoute
                        query.bak = res.data.bak
                        query.username = res.data.username
                        query.game = encodeURIComponent(query.game);
                        window.history.replaceState({}, document.title,
                            `${window.location.origin}${router.currentRoute.path}?${Object.entries(
                                query).
                                map(([key, value]) => `${key}=${value}`).
                                join('&')}`)

                        // 2022.04.11 注册成功后回传账号名给安卓端
                        try {
                            const rgName = res?.data?.username || ''
                            window?.JHJsImpl?.register?.(rgName)
                            console.log('JHJsImpl.register<Android> | >>> ', rgName)

                        // 2024.01.16 安卓新壳包
                        window?.JsJingYouNativeBridge?.jsJingYouLogin?.(1, rgName)
                        console.log('JsJingYouNativeBridge.jsJingYouLogin<Android> | >>> ', rgName)
                        } catch (err) {
                            console.log('回传安卓端失败：', err)
                        }
                    }
                    resolve(res)
                }).catch(reject)
            })
        },
        // 更新验证信息
        updateVerifyInfo({ commit, dispatch }, info) {
            console.log('dfsdfjjsdfl', info)
            const {
                id_card = '',
                is_verified = false,
                anti = 0,
                api_time = 0,
            } = info

            const verifyInfo = {
                id_card,
                is_verified,
                anti,
                api_time,
            }
            commit('UPDATE_VERIFY_INFO', verifyInfo)
        },
        // 游戏打点（未成年用户限时游玩）
        async pointPlaytime({ state, dispatch }) {
            const { api_time } = state.verifyInfo
            if (VerifyPointingTimer) {
                await dispatch('stopPointPlaytime')
            }
            if (api_time) {
                const { accountData } = state
                const { appConfig } = state.app
                VerifyPointingTimer = setTimeout(() => {
                    collectPlayTime({
                        username: accountData.username,
                        game_id: appConfig.game_id,
                        platform: appConfig.platform,
                        sys_platform: appConfig.sys_platform,
                    }).then((res) => {
                        // if (Number(res.code) === -1) {
                        //     const exitGame = () => {
                        //         window.postMessage(
                        //             { key: 'reLogin', value: true }, '*')
                        //     }
                        //     dispatch('stopPointPlaytime')
                        //     const timer = setTimeout(() => {
                        //         exitGame()
                        //     }, 5000)
                        //     Dialog.alert({
                        //         title: '提示',
                        //         message: `${res.msg || '登录已过期'}\n（五秒后退出游戏）`,
                        //         beforeClose: (action, done) => {
                        //             exitGame()
                        //             clearTimeout(timer)
                        //             done()
                        //         },
                        //         confirmButtonText: '立即退出',
                        //     })
                        // }
                        if (Number(res.code) === -1 || Number(res.code) === -2) {
                            const exitGame = () => {
                                window.postMessage(
                                    { key: 'reLogin', value: true }, '*')
                            }
                            dispatch('stopPointPlaytime')
                            exitGame()
                            Dialog.alert({
                                title: $t('提示'),
                                message: `${res.msg }`,
                                beforeClose: (action, done) => {
                                    done()
                                },
                                confirmButtonText: '确定',
                            })
                        } 
                    }).finally(() => {
                        dispatch('pointPlaytime')
                    })
                }, api_time * 1000)
            }
        },
        // 停止游戏打点
        stopPointPlaytime() {
            clearTimeout(VerifyPointingTimer)
            VerifyPointingTimer = null
        },
        // 获取礼包码列表
        getCodeList({ commit, state }) {
            return getCodeList({ game_id: state.app.appConfig.game_id }).
                then(res => {
                    console.log('getCodeList res ', res)
                    if (Number(res.code) === 0) {
                        return commit('UPDATE_ALL_CODE_LIST', res.data)
                    }
                })
        },
        // 获取我的礼包码列表
        getMyCode({ commit, state }) {
            return getMyCode({ game_id: state.app.appConfig.game_id }).
                then(res => {
                    console.log('getMyCode res ', res)
                    if (Number(res.code) === 0) {
                        return commit('UPDATE_MY_CODE_LIST', res.data)
                    }
                })
        },
        // 弹框公告
        getNewNotice({ commit, state }) {
            return getNewNotice({ game_id: state.app.appConfig.game_id }).
                then(res => {
                    console.log('getNewNotice res ', res)
                    if (Number(res.code) === 0) {
                        return commit('UPDATE_NOTICE', res.data)
                    }
                })
        },
        updateFirstOpen({ commit, dispatch }, bol) {
            commit('UPDATE_FIRST_OPEN', bol)
        },
        updateIsFirstOpenByLogin({ commit, dispatch }, bol) {
            commit('UPDATE_IS_FIRST_OPEN_BY_LOGIN', bol)
        },
    },
    mutations: {
        ADD_ACCOUNT(state, accountData) {
            state.localAccounts.push(accountData)
            setAccounts(state.localAccounts)
        },
        UPDATE_ACCOUNT_DATA(state, accountData) {
            state.accountData = { ...accountData }
        },
        UPDATE_GAME_URL(state, url) {
            state.gameUrl = url
        },
        UPDATE_GAME_FRAME_CONTENT(state, frame) {
            state.gameFrameInfo.frame = frame
        },
        UPDATE_GAME_SERVICE(state, data) {
            state.serviceInfo = data
        },
        /* 保存验证信息 */
        UPDATE_VERIFY_INFO(state, info) {
            state.verifyInfo = info
        },
        UPDATE_ALL_CODE_LIST(state, data) {
            state.allCodeList = data
        },
        UPDATE_MY_CODE_LIST(state, data) {
            state.myCodeList = data
        },
        UPDATE_NOTICE(state, data) {
            state.notice = data
        },
        UPDATE_FIRST_OPEN(state, bol) {
            state.firstOpen = bol
        },
        UPDATE_IS_FIRST_OPEN_BY_LOGIN(state, bol) {
            state.isFirstOpenByLogin = bol
        },
    },
})
